// test833
(833 && 0);
